import MUIList from "@mui/material/List";

export const List = MUIList;

export default List;
